import { getSystemSignway } from "@/api/system.js";

const state = {
  systemSignwayList: {}, // 系统支持签约方式
  systemSignwayListUpdate: null // 系统支持签约方式更新时间
};

const mutations = {
  SET_SYSTEMSIGNWAY: (state, data) => {
    state.systemSignwayList = data;
    state.systemSignwayListUpdate = new Date().getTime();
  }
};

const actions = {
  async getSystemSignway({ commit, state }) {
    if (state.systemSignwayListUpdate === null) {
      const { data: taxDetail } = await getSystemSignway({ type: 0 });
      const { data: taxList } = await getSystemSignway({ type: 1 });
      const { data: cooperation } = await getSystemSignway({ type: 2 });
      const { data: contract } = await getSystemSignway({ type: 3 });
      commit("SET_SYSTEMSIGNWAY", { contract, taxDetail, taxList, cooperation });
    }
    //     1-服务商详情
    // 2-服务商筛选
    // 3-协议筛选
    // 4-签约明细筛选
    return state.systemSignwayList;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
